import SessionStorage from "../storage/SessionStorage.js";

const UserSession = (function() {
  const getUser = function() {
    return SessionStorage.retreive("user");
  };

  const setUser = function(user) {
    SessionStorage.persist("user", user);
  };

  const deleteUser = function() {
    SessionStorage.remove("user");
  };

  const existsUser = function() {
    return SessionStorage.exists("user");
  };

  const isUserLoggedIn = function() {
    const userExists = existsUser();
    const isUserLoggedIn = userExists;
    return isUserLoggedIn;
  };

  const deleteUserSession = function() {
    deleteUser();
  };

  return {
    getUser: getUser,
    setUser: setUser,
    deleteUser: deleteUser,
    isUserLoggedIn: isUserLoggedIn,
    deleteUserSession: deleteUserSession
  };
})();

export default UserSession;
